// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__6tTdG","productName":"Table_productName__13BOP"};